import {
  clearDebugEvents,
  getDebugEvents,
  subscribeToDebugEvents,
} from "../debug-store";
import type { ErrorLogEntry, ErrorLogListener } from "./error-log-store.types";

export type { ErrorKind, ErrorLogEntry } from "./error-log-store.types";

export const ERROR_LOG_LIMITS = { entries: 100 } as const;
const SERVER_SNAPSHOT: ErrorLogEntry[] = [];
let sourceSnapshot = getDebugEvents();
let errorSnapshot: ErrorLogEntry[] = [];

export function subscribeErrorLog(listener: ErrorLogListener): () => void {
  return subscribeToDebugEvents(listener);
}

export function getErrorLogEntries(): ErrorLogEntry[] {
  const currentEvents = getDebugEvents();
  if (currentEvents !== sourceSnapshot) {
    sourceSnapshot = currentEvents;
    errorSnapshot = currentEvents
      .filter(
        (event) =>
          event.status === "failed" || event.status === "outcome-unknown",
      )
      .map((event) => ({
        id: String(event.id),
        kind: "js-error" as const,
        message: event.errorCode ?? event.status,
        occurrences: 1,
        source: event.route,
        timestamp: event.occurredAt,
      }))
      .reverse();
  }
  return errorSnapshot;
}

export function getServerSnapshotErrorLog(): ErrorLogEntry[] {
  return SERVER_SNAPSHOT;
}

export function serializeErrorLogEntries(entries: ErrorLogEntry[]): string {
  return JSON.stringify(
    entries.map(({ kind, message, occurrences, source, timestamp }) => ({
      kind,
      message,
      occurrences,
      source,
      timestamp,
    })),
    null,
    2,
  );
}

export function clearErrorLog(): void {
  clearDebugEvents();
}

export function initErrorTracker(): void {
  // Arbitrary console, stack, and window error capture is intentionally off.
}

export function disposeErrorTracker(): void {
  // No global interception is installed.
}
